<mat-card class="daxa-card recent-orders-card border-radius bg-white border-none d-block p-3">
  <mat-card-header>
    <mat-card-title>
      <form class="search-box position-relative">
        <i class="material-symbols-outlined" style="font-size: medium;">search</i>
        <input type="text" class="input-search d-block w-100 border-none outline-0 rounded-pill"
               placeholder="Chercher une fiche..." (keyup)="applyFilter($event)" #input>
      </form>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        <!-- Checkbox Select -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="handleSelectAll()" [checked]="isAllFichePaillasseSelected"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox [checked]="isAllFichePaillasseSelected" (change)="handleSelection(element)"></mat-checkbox>
          </td>
        </ng-container>

        <!-- Sample ID -->
        <ng-container matColumnDef="sampleId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Échantillon</th>
          <td mat-cell *matCellDef="let fiche">{{ fiche.sampleCode }}</td>
        </ng-container>

        <!-- Code Fiche -->
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Code Fiche</th>
          <td mat-cell *matCellDef="let fiche">{{ fiche.code }}</td>
        </ng-container>

        <!-- Date création -->
        <ng-container matColumnDef="creationDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date création</th>
          <td mat-cell *matCellDef="let fiche">{{ fiche.creationDate | date:'short' }}</td>
        </ng-container>
        <ng-container matColumnDef="statut">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Statut</th>
          <td mat-cell *matCellDef="let fiche">{{ fiche.statut }}</td>
        </ng-container>
        <!-- Étapes -->
        <ng-container matColumnDef="steps">
          <th mat-header-cell *matHeaderCellDef>Étapes</th>
          <td mat-cell *matCellDef="let fiche">
            <ul>
              <li *ngFor="let step of fiche.steps">{{ step.titre }}</li>
            </ul>
          </td>
        </ng-container>
        <ng-container matColumnDef="progressionTexte">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Avancement</th>
          <td mat-cell *matCellDef="let fiche">{{ fiche.progressionTexte }}</td>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="text-center">Actions</th>
          <td mat-cell *matCellDef="let fiche" class="text-center">
            <button mat-button matTooltip="Saisir les résultats" matTooltipPosition="above"
                    (click)="openEditModal(fiche)">
              <i class="material-symbols-outlined">assignment</i>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
<!-- Modal Edit Fiche -->
<ng-template #editModal let-modal>

    <!-- HEADER -->
    <mat-card-header>
      <mat-card-title>
        <h5 class="mt-0 mb-0">
          Fiche de paillasse – {{ selectedFiche.code }}
        </h5>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>

      <!-- ===================== -->
      <!-- 1️⃣ ETAPES DE PAILLASSE -->
      <!-- ===================== -->
      <h6 class="mb-2">Étapes de paillasse</h6>

      <div class="table-responsive mb-3">
        <table class="table table-bordered align-middle">
          <thead class="table-light">
            <tr>
              <th>Titre</th>
              <th>Réalisé</th>
              <th>Concentration</th>
              <th>Unité</th>
              <th>Date</th>
              <th>Statut</th>
              <th>Commentaire</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let step of selectedFiche.steps">
              <td>{{ step.titre }}</td>
              <td class="text-center">
                <input type="checkbox"
                       [(ngModel)]="step.realise"
                       [disabled]="step.realiseApplicable === false">
              </td>
              <td>
                <input class="form-control form-control-sm"
                       [(ngModel)]="step.valeurMesuree"
                       [disabled]="!step.realise || step.valeurApplicable === false">
              </td>
              <td>
                <select class="form-control form-control-sm"
                        [(ngModel)]="step.unite"
                        [disabled]="!step.realise || step.uniteApplicable === false">
                  <option *ngFor="let u of uniteOptions" [value]="u">{{ u }}</option>
                </select>
              </td>
              <td>
                <input type="datetime-local" class="form-control form-control-sm"
                       [(ngModel)]="step.dateRealisation"
                       [disabled]="!step.realise || step.dateApplicable === false">
              </td>
              <td>
                <select class="form-control form-control-sm" [(ngModel)]="step.statut"
                        [disabled]="!step.realise">
                  <option value="VALIDATED">Validé</option>
                  <option value="INCIDENT">Incident</option>
                </select>
              </td>
              <td>
                <input *ngIf="step.statut === 'INCIDENT'"
                       class="form-control form-control-sm"
                       [(ngModel)]="step.commentaire"
                       placeholder="Raison de l'incident">
              </td>
                <td class="text-center">
                <button class="btn btn-outline-success btn-sm"
                        [disabled]="!step.realise"
                        (click)="saveStep(step)">
                <i class="fas fa-check"></i> <!-- icône check -->
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Bouton "Enregistrer Fiche" après Étapes de paillasse 
      <div class="mb-4 text-end">
        <button class="btn btn-success btn-sm" (click)="saveFiche(selectedFiche)">
          Enregistrer Fiche
        </button>
      </div>
-->
      <!-- ===================== -->
      <!-- 2️⃣ ANALYSES INSTRUMENTALES -->
      <!-- ===================== -->
      <h6 class="mb-3">Analyses instrumentales</h6>

      <button class="btn btn-outline-primary btn-sm mb-3" (click)="addAnalyseInstrumentale()">
        + 
      </button>

      <form [formGroup]="ficheForm">
  <div formArrayName="analysesInstrumentales">
    <div *ngFor="let ai of analysesInstrumentales.controls; let i = index"
         [formGroupName]="i"
         class="card mb-3 shadow-sm border-0 rounded-2 p-3">

      <!-- Card Header -->
      <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
        <h6 class="mb-0 text-primary">Analyse instrumentale {{ i + 1 }}</h6>
        <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeAnalyse(i)">
          <i class="material-symbols-outlined text-danger">delete</i>
        </button>
      </div>

      <!-- Card Body -->
      <div class="row g-3">
        <!-- Ligne 1 : Type instrument, Statut, Date analyse -->
        <div class="col-md-4">
          <label class="form-label fw-semibold">Type d’instrument</label>
          <select class="form-select" formControlName="typeInstrument"
                  (change)="onTypeInstrumentChange(i)">
            <option [ngValue]="null">-- Sélectionner --</option>
            <option *ngFor="let t of typeInstruments" [value]="t">{{ t }}</option>
          </select>
        </div>

        <div class="col-md-4">
          <label class="form-label fw-semibold">Statut</label>
          <select class="form-select" formControlName="statut">
            <option value="PLANIFIEE">Planifiée</option>
            <option value="REALISEE">Réalisée</option>
            <option value="VALIDEE">Validée</option>
          </select>
        </div>

        <div class="col-md-4">
          <label class="form-label fw-semibold">Date analyse</label>
          <input type="datetime-local" class="form-control" formControlName="dateAnalyse">
        </div>

        <!-- Ligne 2 : Méthode instrumentale, Emplacement fichier -->
        <div class="col-md-6">
        <label class="form-label fw-semibold">Méthode instrumentale</label>
        <select class="form-select" formControlName="methodeInstrumentale">
          <option [ngValue]="null">-- Sélectionner --</option>
          <option *ngFor="let m of methodesDisponibles[i]" [ngValue]="m">
            {{ m.codeMethode }} v{{ m.version }}
          </option>
        </select>
      </div>

      <!-- Emplacement / Upload fichier -->
      <div class="col-md-6">
        <label class="form-label fw-semibold">Emplacement du fichier</label>
        <input type="file" class="form-control" (change)="onFileSelectedMethod($event, i)">
        <input type="hidden" formControlName="emplacement"> <!-- stocke le chemin ou nom du fichier -->
      </div>
        <!-- Ligne 3 : Batch analytique, Date création batch -->
        <div class="col-md-6">
  <label class="form-label fw-semibold">Batch analytique (upload)</label>
  <input type="file" class="form-control" (change)="onFileSelected($event, i)">
</div>

<div class="col-md-6">
  <label class="form-label fw-semibold">Date création batch</label>
  <input type="datetime-local" class="form-control" formControlName="dateCreationBatch" [readonly]="true">
</div>

      </div>
    </div>
  </div>
</form>

<!-- Boutons Annuler et Enregistrer Analyses  -->
<div class="d-flex justify-content-end mt-4 gap-2">
  <button class="btn btn-outline-secondary btn-sm" (click)="modal.close()">Annuler</button>
  <button class="btn btn-primary btn-sm" 
          (click)="saveAnalysesInstrumentales()"
          >
    <i class="bi bi-save"></i> Terminer
  </button>
</div>


    </mat-card-content>
</ng-template>
